(function () {
  function cleanVendorText(el) {
    if (!el) return '';

    // Clone so we can remove sr-only text
    const clone = el.cloneNode(true);
    const sr = clone.querySelector('.sr-only');
    if (sr) sr.remove();

    return clone.textContent.trim().toLowerCase();
  }

  function hideProducts() {
    const cards = document.querySelectorAll('.product-card');

    cards.forEach(card => {
      if (card.dataset.hideChecked === "true") return;

      // --- Metafield ---
      const hasMeta = card.getAttribute('data-hide-from-store') === 'true' ||
                      card.querySelector('.js-hide-from-store-flag');

      // --- Vendor ---
      const vendorLink = card.querySelector('.product-card__top a');
      const vendor = cleanVendorText(vendorLink);
      const isPrivate = vendor === 'meama private';

      if (hasMeta || isPrivate) {
        card.dataset.hideChecked = "true";
        card.style.display = "none"; // safer than remove() with theme animations
      } else {
        card.dataset.hideChecked = "true";
      }
    });
  }

  function runWatcher() {
    hideProducts();

    const observer = new MutationObserver(() => {
      hideProducts();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Extra safety cycles (Shopify themes love delayed rendering)
    setInterval(hideProducts, 1000);
  }

  if (document.readyState === 'complete') {
    runWatcher();
  } else {
    window.addEventListener('load', runWatcher);
  }
})();
